export const REDUCERS = {
  AUTH: {
    CHECK_AUTHENTICATION_ERROR: 'auth/CHECK_AUTHENTICATION_ERROR',
    API_CHECK_AUTHENTICATION_REQUEST: 'auth/API_CHECK_AUTHENTICATION_REQUEST',
    API_CHECK_AUTHENTICATION_SUCCESS: 'auth/API_CHECK_AUTHENTICATION_SUCCESS',
    API_REFRESH_SUCCESS: 'auth/API_REFRESH_SUCCESS',
    DEV_LOGIN_SUCCESS: 'auth/DEV_LOGIN_SUCCESS',
    DEV_LOGIN_ERROR: 'auth/DEV_LOGIN_ERROR',
  },
  APP: {
    RESET_ALL_STATE: 'app/RESET_ALL_STATE',
    SET_PRACTICE: 'app/SET_PRACTICE',
    SET_USER_DATA: 'app/SET_USER_DATA',
    SET_INJECTED_TRANSCRIPT: 'app/SET_INJECTED_TRANSCRIPT',
    SET_EDITING_SUMMARY: 'app/SET_EDITING_SUMMARY',
  },
  WALLET: {
    SET_SHOW_DAY_PASS_FLAG: 'wallet/SET_SHOW_DAY_PASS_FLAG',
    GET_WALLET_REQUEST: 'wallet/GET_WALLET_REQUEST',
    GET_WALLET_SUCCESS: 'wallet/GET_WALLET_SUCCESS',
    GET_WALLET_ERROR: 'wallet/GET_WALLET_ERROR',
    GET_ORDERS_REQUEST: 'wallet/GET_ORDERS_REQUEST',
    GET_ORDERS_SUCCESS: 'wallet/GET_ORDERS_SUCCESS',
    GET_ORDERS_ERROR: 'wallet/GET_ORDERS_ERROR',
    GET_PRODUCTS_REQUEST: 'wallet/GET_PRODUCTS_REQUEST',
    GET_PRODUCTS_SUCCESS: 'wallet/GET_PRODUCTS_SUCCESS',
    GET_PRODUCTS_ERROR: 'wallet/GET_PRODUCTS_ERROR',
    DELETE_ORDER_REQUEST: 'wallet/DELETE_ORDER_REQUEST',
    DELETE_ORDER_SUCCESS: 'wallet/DELETE_ORDER_SUCCESS',
    DELETE_ORDER_ERROR: 'wallet/DELETE_ORDER_ERROR',
    ACCEPT_TERMS_REQUEST: 'wallet/ACCEPT_TERMS_REQUEST',
    ACCEPT_TERMS_SUCCESS: 'wallet/ACCEPT_TERMS_SUCCESS',
    ACCEPT_TERMS_ERROR: 'wallet/ACCEPT_TERMS_ERROR',
  },
  TRANSCRIPTION: {
    RESET_TRANSCRIPTION: 'transcription/RESET_TRANSCRIPTION',
    ADD_TRANSCRIPTION: 'transcription/ADD_TRANSCRIPTION',
    ADD_TRANSCRIPTIONS: 'transcription/ADD_TRANSCRIPTIONS',
    DELETE_TRANSCRIPTION: 'transcription/DELETE_TRANSCRIPTION',
  },
  SUMMARY: {
    SET_CONSULATION_ID: 'summary/SET_CONSULATION_ID',
    START_SUMMARY_REQUEST: 'summary/START_SUMMARY_REQUEST',
    GET_SUMMARY: 'summary/GET_SUMMARY',
    ERROR_SUMMARY_REQUEST: 'summary/ERROR_SUMMARY_REQUEST',
    UPDATE_SUMMARY: 'summary/UPDATE_SUMMARY',
    RESET_SUMMARY_STATE: 'summary/RESET_SUMMARY_STATE',
  },
  WEBSOCKET: {
    CONNECTION_OPEN: 'websocket/CONNECTION_OPEN',
    CONNECTION_CLOSE: 'websocket/CONNECTION_CLOSE',
    CONNECTION_FAILED: 'websocket/CONNECTION_FAILED',
    MESSAGE_ERROR: 'websocket/MESSAGE_ERROR',
  },
  FEATURE_FLAGS: {
    GET_FEATURE_FLAGS_REQUEST: 'featureFlags/GET_FEATURE_FLAGS_REQUEST',
    GET_FEATURE_FLAGS_SUCCESS: 'featureFlags/GET_FEATURE_FLAGS_SUCCESS',
    GET_FEATURE_FLAGS_ERROR: 'featureFlags/GET_FEATURE_FLAGS_ERROR',
  },
  TOOLBAR: {
    GET_CURRENT_PATIENT_REQUEST: 'toolbar/GET_CURRENT_PATIENT_REQUEST',
    GET_CURRENT_PATIENT_RESPONSE: 'toolbar/GET_CURRENT_PATIENT_RESPONSE',
    GET_CURRENT_PATIENT_FAILED: 'toolbar/GET_CURRENT_PATIENT_FAILED',
    WRITE_TO_RECORD_REQUEST: 'toolbar/WRITE_TO_RECORD_REQUEST',
    WRITE_TO_RECORD_RESPONSE: 'toolbar/WRITE_TO_RECORD_RESPONSE',
    WRITE_TO_RECORD_FAILED: 'toolbar/WRITE_TO_RECORD_FAILED',
    RESET_TOOLBAR_STATUS: 'toolbar/RESET_TOOLBAR_STATUS',
  },
  SNOMED: {
    SET_VITAL: 'snomed/SET_VITAL',
    RESET_SNOMED: 'snomed/RESET_TOOLBAR_STATUS',
    TOGGLE_SELECTED_SNOMED: 'snomed/TOGGLE_SELECTED_SNOMED',
    SET_PROBLEM_SNOMED_CODE: 'snomed/SET_PROBLEM_SNOMED_CODE',
    AI_SNOMED_REQUEST_PENDING: 'snomed/AI_SNOMED_REQUEST_PENDING',
    AI_SNOMED_REQUEST_SUCCESS: 'snomed/AI_SNOMED_REQUEST_SUCCESS',
    AI_SNOMED_REQUEST_FAILED: 'snomed/AI_SNOMED_REQUEST_FAILED',
    AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_PENDING: 'snomed/AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_PENDING',
    AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_SUCCESS: 'snomed/AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_SUCCESS',
    AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_FAILED: 'snomed/AI_SNOMED_CODE_COUNT_UPDATE_REQUEST_FAILED',
  },
  COPILOT: {
    COPILOT_QUERY_REQUEST: 'copilot/COPILOT_QUERY_REQUEST',
    COPILOT_QUERY_SUCCESS: 'copilot/COPILOT_QUERY_SUCCESS',
    COPILOT_QUERY_FAILURE: 'copilot/COPILOT_QUERY_FAILURE',
    UPDATE_QUERY: 'copilot/UPDATE_QUERY',
    RESET_COPILOT_QUERY_AND_RESPONSE: 'copilot/RESET_COPILOT_QUERY_AND_RESPONSE',
    CLEAR_COPILOT_RESPONSE: 'copilot/CLEAR_COPILOT_RESPONSE',
    COPILOT_LETTER_SUMMARY_SUCCESS: 'copilot/COPILOT_LETTER_SUMMARY_SUCCESS',
    CLEAR_LETTER_SUMMARY: 'copilot/CLEAR_LETTER_SUMMARY',
  },
  TEMPLATES_REDUCER: {
    GET_TEMPLATES_REQUEST: 'templates/GET_TEMPLATES_REQUEST',
    GET_TEMPLATES_SUCCESS: 'templates/GET_TEMPLATES_SUCCESS',
    GET_TEMPLATES_ERROR: 'templates/GET_TEMPLATES_ERROR',
    UPDATE_TEMPLATE_REQUEST: 'templates/UPDATE_TEMPLATE_REQUEST',
    UPDATE_TEMPLATE_SUCCESS: 'templates/UPDATE_TEMPLATE_SUCCESS',
    UPDATE_TEMPLATE_ERROR: 'templates/UPDATE_TEMPLATE_ERROR',
    SELECT_TEMPLATE: 'templates/SELECT_TEMPLATE',
    SELECT_TEMPLATE_IN_TEMPLATE_MANAGER: 'templates/SELECT_TEMPLATE_IN_TEMPLATE_MANAGER',
    CLEAR_TEMPLATE_IN_TEMPLATE_MANAGER: 'templates/CLEAR_TEMPLATE_IN_TEMPLATE_MANAGER',
    UPDATE_TEMPLATE_NAME: 'templates/UPDATE_TEMPLATE_NAME',
    UPDATE_TEMPLATE_PRACTICE_ROLE: 'templates/UPDATE_TEMPLATE_PRACTICE_ROLE',
    UPDATE_TEMPLATE_TRANSCRIPTION_TYPE: 'templates/UPDATE_TEMPLATE_TRANSCRIPTION_TYPE',
    UPDATE_TEMPLATE_CONTENT: 'templates/UPDATE_TEMPLATE_CONTENT',
    UPDATE_TEMPLATE_TYPE: 'templates/UPDATE_TEMPLATE_TYPE',
    SET_SHOW_TEMPLATE_VALIDATION: 'templates/SET_SHOW_TEMPLATE_VALIDATION',
    ADD_NEW_TEMPLATE_REQUEST: 'templates/ADD_NEW_TEMPLATE_REQUEST',
    ADD_NEW_TEMPLATE_SUCCESS: 'templates/ADD_NEW_TEMPLATE_SUCCESS',
    ADD_NEW_TEMPLATE_ERROR: 'templates/ADD_NEW_TEMPLATE_ERROR',
    SAVE_TEMPLATE_REQUEST: 'templates/SAVE_TEMPLATE_REQUEST',
    SAVE_TEMPLATE_SUCCESS: 'templates/SAVE_TEMPLATE_SUCCESS',
    SAVE_TEMPLATE_ERROR: 'templates/SAVE_TEMPLATE_ERROR',
    DELETE_TEMPLATE_REQUEST: 'templates/DELETE_TEMPLATE_REQUEST',
    DELETE_TEMPLATE_SUCCESS: 'templates/DELETE_TEMPLATE_SUCCESS',
    DELETE_TEMPLATE_ERROR: 'templates/DELETE_TEMPLATE_ERROR',
    TOGGLE_SAVE_TEMPLATE_DIALOG: 'templates/TOGGLE_SAVE_TEMPLATE_DIALOG',
    TOGGLE_NEW_MESSAGE_SAVE_TEMPLATE_DIALOG: 'templates/TOGGLE_NEW_MESSAGE_SAVE_TEMPLATE_DIALOG',
    UPDATE_TEMPLATE_FILTER: 'templates/UPDATE_TEMPLATE_FILTER',
    UPDATE_TEMPLATE_TITLE: 'templates/UPDATE_TEMPLATE_TITLE',
  },
};
